module.exports = __webpack_public_path__ + "static/assets/6f52bcc0310181641bac6fec51c69e13.svg";